import Phaser from 'phaser';

import { GameBoardViewModel } from './game-board-view-model';
import { StartView } from '../components/start-view';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';
import { TextService } from '../../services/text-service';
import { CardDeckView } from '../entities/card-deck-view';
import { TwentyOneMainScene } from '../../scenes/twentyone-main-scene';
import { NextView } from '../entities/next-view';
import { CurrentView } from '../entities/current-view';
import { ColumnView } from '../entities/column-view';
import { LoadingColumnView } from '../entities/loading-column-view';

export class GameBoardView extends Phaser.GameObjects.Container {
  private textService: TextService;

  private cardDeckView: CardDeckView;
  private nextView: NextView;
  private currentView: CurrentView;
  private loadingColumnViews: LoadingColumnView[];
  private columnViews: ColumnView[];
  private startView: StartView;

  constructor(
    scene: TwentyOneMainScene,
    x: number,
    y: number,
    private viewModel: GameBoardViewModel,
  ) {
    super(scene, x, y);

    this.textService = new TextService(
      scene,
      this,
      viewModel.defaultFontFamily,
      viewModel.layoutConfig.availableTextWidth,
    );

    this.cardDeckView = new CardDeckView(scene, 0, 0, viewModel.cardDeckViewModel);
    this.add(this.cardDeckView);

    this.nextView = new NextView(scene, 0, 0, viewModel.nextViewModel);
    this.add(this.nextView);

    this.currentView = new CurrentView(scene, 0, 0, viewModel.currentViewModel);
    this.add(this.currentView);

    this.loadingColumnViews = viewModel.loadingColumnViewModels.map(
      (loadingColumnViewModel) => new LoadingColumnView(scene, 0, 0, loadingColumnViewModel),
    );
    this.add(this.loadingColumnViews);

    this.columnViews = viewModel.columnViewModels.map(
      (columnViewModel) => new ColumnView(scene, 0, 0, columnViewModel),
    );
    this.add(this.columnViews);

    this.startView = new StartView(scene, 0, 0, viewModel.startViewModel);
    this.add(this.startView);

    this.setName(GameBoardView.name);
    scene.add.existing(this);

    scene.input.keyboard?.on('keydown-K', viewModel.copyTestCase, viewModel);
  }

  public onResize(gameSizeMetrics: GameSizeMetrics) {
    const scalingMetrics = this.viewModel.calculateScaleFactor(gameSizeMetrics);
    const scaledFontMetrics = this.textService.refreshFontSizes(scalingMetrics.scaleFactor);

    const resizeMetrics = {
      layoutConfig: this.viewModel.layoutConfig,
      sizeMetrics: gameSizeMetrics,
      scalingMetrics: scalingMetrics,
      fontMetrics: scaledFontMetrics,
    };

    this.cardDeckView?.onResize(resizeMetrics);
    this.nextView?.onResize(resizeMetrics);
    this.currentView?.onResize(resizeMetrics);
    this.loadingColumnViews.forEach((view) => view.onResize(resizeMetrics));
    this.columnViews.forEach((view) => view.onResize(resizeMetrics));
    this.startView?.onResize(resizeMetrics);
  }
}
